import type { UserPublic } from '@repo/types/users';

import type { ChildrenResourceResult } from './useChildrenResource';

import { ParentKey } from './keys';
import { ParentService } from './parentService';
import { useChildrenResource } from './useChildrenResource';

/**
 * Teachers of every linked child, aggregated. Deduplicate across children at the call site — a teacher may appear under several children.
 */
export function useGetChildrenTeachers(children: UserPublic[], enabled = true): ChildrenResourceResult<UserPublic[]> {
  return useChildrenResource(
    children,
    (child) => [ParentKey.CHILD_TEACHERS, child.id],
    (child) => ParentService.getChildTeachers(child.id).then((response) => response.data),
    enabled
  );
}
